<template>
    <div class="viewport">
      <div class="col-lg-3 col-md-5 auth-form">
        <div class="card">
          <div class="card-body">
            <img class="auth-form__logo d-table mx-auto mb-3" src="img/icons/icon.png" alt="Shards Dashboards - Register Template">
            <h5 class="auth-form__title text-center mb-4">
              <b>Integral-it</b>
            </h5>
            <form>
              <div class="form-group">
                <label for="exampleInputEmail1">Dirección de correo electrónico</label>
                <input type="email" class="form-control" :class="error.email.status" placeholder="Correo electrónico" v-model="form.email">
                <div class="invalid-feedback">
                  {{ error.email.message[0] }}
                </div>
              </div>
              <div class="form-group">
                <label for="exampleInputPassword1">Contraseña</label>
                <input type="password" class="form-control" :class="error.password.status" placeholder="Contraseña" v-model="form.password">
                <div class="invalid-feedback">
                  {{ error.password.message[0] }}
                </div>
              </div>
              <div class="form-group mb-3 d-table mx-auto">
              </div>

              <button @click.prevent="signIn" class="btn btn-pill btn-accent d-table mx-auto" v-if="isLoading==false">Acceder</button>
              <div class="text-center" v-if="isLoading==true">
                <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
              </div>
            </form>
          </div>
        </div>
        <div class="auth-form__meta mt-4 text-center">
          <router-link to="/restaurar">¿Olvidaste tu contraseña?</router-link>
        </div>
      </div>
    </div>
</template>

<style>
	.viewport {
    display: flex;
    justify-content: center;
    align-items: center;
		width: 100vw;
		height: 100vh;
	}
</style>

<script>
	import axios from 'axios'
	export default {
		data() {
			return {
        isLoading: false,
				form: {
					email: '',
					password: ''
				},
        error: {
          email: {
            status: '',
            message: ''
          },
          password: {
            status: '',
            message: ''
          }
        }
			}
		},

		methods: {
      cleanErrors() {
        this.error.email.status = '';
        this.error.email.message = '';
        this.error.password.status = '';
        this.error.password.message = '';
      },

			signIn() {
        this.isLoading = true;
        let email = this.form.email;
        let password = this.form.password;
        this.cleanErrors();
        this.$store.dispatch('sign_in', { email, password })
          .then(response => {
            this.$router.replace('/escritorio');
          })
          .catch(err => {
            switch (err.response.status) {
              case 401:
                  this.isLoading = false, 
                  this.error.email.status = 'is-invalid';
                  this.error.email.message = ['Usuario o contraseña inválido'];
                break;
              case 422:
                this.isLoading = false;
                let errors = err.response.data.errors;
                if(errors.email) {
                    this.error.email.status = 'is-invalid';
                    this.error.email.message = errors.email;
                }

                if(errors.password) {
                    this.error.password.status = 'is-invalid';
                    this.error.password.message = errors.password;
                }
                break;
              case 500:
                this.isLoading = false;
                this.cleanErrors();
                this.$toasted.show("<i class='fas fa-exclamation-triangle'></i> Ha ocurrido un error inesperado.", { 
                   theme: "bubble", 
                   position: "top-right", 
                   duration : 2000
                });
                break;
            }
          });
			}
		}
	}
</script>